import React from 'react';
import EditHospitalForm from '../../components/EditHospitalForm';

function EditHospitalData() {
  return (
    <main>
      <div className='mx-auto max-w-7xl sm:px-6 lg:px-8'>
        <div className='px-4 sm:px-0'>
          <EditHospitalForm />
        </div>
      </div>
    </main>
  );
}

export default EditHospitalData;
